import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import apiRequest from '@/services/requests';
import Header from '@/components/ui/Header';
import Pagination from './components/Pagination';
import PageHeader from './components/PageHeader';
import ListView from './components/ListView';
import {LoadingState, EmptyState} from './components/LoadingState';



const Notifications = () => {
const [list, setList] = useState([]);
const [page, setPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [totalResults, setTotalResults] = useState(0);
const [loading, setLoading] = useState(true);
const resultsPerPage = 10;
const [filters, setFilters] = useState({
job_title: '',
dateFrom: '',
dateTo: '',
});

const loadList = async () => {
setLoading(true);
const res = await apiRequest.notificationList({ page, perPage: 10,...filters });
setList(res.list);
setTotalResults(res.totalResults);
setTotalPages(res.totalPages);
setLoading(false);
};

useEffect(() => {
loadList();
}, [page, filters]);

// Auto mark read after landing
useEffect(() => {
const timer = setTimeout(() => {
apiRequest.notificationUpdate();
}, 2000);

return () => clearTimeout(timer);
}, []);


const hasActiveFilters = () => {
return filters?.job_title || 
filters?.dateFrom || filters?.dateTo;
};


const handleClearFilters = () => {
setFilters({
job_title: '',
dateFrom: '',
dateTo: ''
});
setPage(1);
};


const handlePageChange = (page_) => {
setPage(page_);
window.scrollTo({ top: 0, behavior: 'smooth' });
};

return (
<div className="min-h-screen bg-background">
<Header />

<main className="pt-16">
<div className="max-w-7xl mx-auto px-6 py-8">

{/* Page Header */}
<PageHeader
loadList={loadList}
loading={loading} />

{loading ? (
<LoadingState />
) : list.length === 0 ? (
<EmptyState 
hasFilters={hasActiveFilters()} 
onClearFilters={handleClearFilters}
/>
) : (
<div className="space-y-3">
{list.map(n => (
<ListView
key={n?.id} 
n={n}
/>
))}

<div className="mt-6">
{/* Pagination */}
<Pagination
currentPage={page}
totalPages={totalPages}
totalResults={totalResults}
resultsPerPage={resultsPerPage}
onPageChange={handlePageChange}
isLoading={loading}
/>
</div>

</div>
)}


</div>
</main>
</div>
);
};

export default Notifications;
